export const DocumentFilingPermissions = {
  submit: 'document_filing_submit',
  manage: 'document_filing_manage',
  review: 'document_filing_review',
  admin: ['document_filing_manage', 'document_filing_review'] as const,
} as const
